export const NONE_FILTER = 'is_none';
